<template lang="pug">
  b-container
    .text-right
      b-button.mb-3(v-if="!account.kanguro_account_uuid", variant="primary", @click="account_modal = true") Completar registro
      b-button.mb-3(v-else variant="success", @click="$emit('createLocation')", :disabled="limit_reached") Crear punto de recolección
    b-row
      b-col(md="12")
        b-card(no-body)
          b-table.card-table.mb-0(:items="recolection_points", responsive, @row-clicked="openPlaceModal($event)", hover, :fields="fields", show-empty)
            template(v-slot:empty)
              p.mb-0.text-secondary No has creado puntos de recolección
            template(v-slot:cell(name)="{ item }")
              .d-flex.align-items-start
                b-img.mr-3(:src="mapsURL + '&markers=color:0x1d91fe|label:L|' + item.latitude + ',' + item.longitude", v-if="item.map_image && !item.error", width="90", height="90", rounded)
                div
                  p.mb-0(v-if="item.name") {{ item.name }}
                  p.mb-0.text-help(v-else) (Sin nombre)
                  p.mb-0.text-secondary {{ item.description }}
                  p.mb-0.text-secondary.text-sm {{ item.disponibility_description }}
                  .mt-2(v-if="item.name || item.description")
                  p.mb-0.text-help.text-sm {{ item.full_address }}
    
    b-modal(v-model="edit_location_modal", title="Editar punto de recolección", ok-title="Guardar", cancel-title="Cancelar", ok-variant="primary", @ok="updateLocation($event)", @hidden="clearModalData")
      b-img.mb-3(:src="mapsURLBig + '&markers=color:0x1d91fe|label:L|' + place.latitude + ',' + place.longitude", fluid, rounded)
      b-form-group
        b-form-textarea(readonly, :value="place.full_address", no-resize, rows="2", max-rows="5")
      b-form-group(label="Nombre de punto de recolección")
        b-form-input(placeholder="Nombre de punto de recolección", v-model="place.name", :state="place.name ? null : (place.validated ? false : null)")
      b-form-group(label="Descripción", description="Trata de que sea una descripción breve.")
        b-form-textarea(placeholder="Descripción breve", v-model="place.description", no-resize, rows="2", max-rows="5")
      //RECOLECTION POINT INFO
      //- b-form-group(label="Teléfono local")
      //-   b-form-input(readonly, v-model="place.home_phone", :state="place.home_phone ? null : (place.validated ? false : null)")
      b-form-group(label="Teléfono")
        b-form-input(readonly, v-model="place.cell_phone", :state="place.cell_phone ? null : (place.validated ? false : null)")
      b-form-group(label="Email de contacto")
        b-form-input(readonly, v-model="place.email", :state="place.email ? null : (place.validated ? false : null)")
      b-form-group(label="Referencias", description="Información adicional que ayuden a localizar el punto de recolección")
        b-form-textarea(readonly, v-model="place.reference", no-resize, rows="2", max-rows="5")
      //- b-form-group(label="Selecciona los días disponibles para recolección de productos:")
      //-   b-form-checkbox-group(:options="availability_days", v-model="availability_days_picked", stacked, :state="availability_days_picked.length ? null : (place.validated ? false : null)")
      //- b-form-group(label="Selecciona los horarios disponibles para recolección de productos:")
      //-   b-row
      //-     b-col(cols="12", v-if="!areTimesPicked")
      //-       p.text-danger.text-sm Seleccionar horarios
      //-     b-col(md="6")
      //-       b-form-group(label="Desde las")
      //-         vue-timepicker(format="hh:mm A", v-model="time_from", hide-clear-button, auto-scroll)
      //-     b-col(md="6")
      //-       b-form-group(label="Hasta las")
      //-         vue-timepicker(format="hh:mm A", v-model="time_to", hide-clear-button, auto-scroll)
      b-form-group(label="Describe la disponibilidad en días y horarios")
        b-form-textarea(v-model="place.disponibility_description", no-resize, rows="2", max-rows="5" :state="place.disponibility_description ? null : (place.validated ? false : null)")
      b-form-group(v-if="place.validated")
        p.mb-0.text-danger.text-sm.text-center * Completa los campos marcados con rojo
    
    b-modal(v-model="account_modal", title="Configuración servicio de paqueteria", ok-title="Guardar", ok-only, ok-variant="primary", hide-footer, no-close-on-backdrop)
      b-img.mb-3(src="@/assets/kanguro-logo.png", height="130", center)
      p Envíos Kanguro se encarga de envíar tus paquetes de forma segura.
      p Proporciona tus datos de contacto y los puntos de recolección donde la paquetería pasará a recoger los paquetes listos para envío.
      p 1. Datos de contacto
      validation-observer(v-slot="{ invalid, dirty, handleSubmit, errors }")
        form.mb-3(@submit.prevent="handleSubmit(registerUser)")
          validation-provider(rules="required" name="nombre completo" v-slot="{ valid, errors }")
            b-form-group
              label.text-secondary Nombre completo
              b-form-input(v-model.trim="account.representative_name", placeholder="Nombre", :state="valid ? null : false")
              b-form-invalid-feedback {{errors[0]}}
          validation-provider(rules="required|email" name="correo" v-slot="{ valid, errors }")
            b-form-group
              label.text-secondary Correo electrónico
              b-form-input(v-model.trim="account.email", placeholder="Email", :state="valid ? null : false")
              b-form-invalid-feedback {{errors[0]}}
          validation-provider(rules="required|digits:10" name="teléfono" v-slot="{ valid, errors }")
            b-form-group
              label.text-secondary Teléfono
              b-form-input(v-model.trim="account.phone", placeholder="Teléfono", :state="valid ? null : false")
              b-form-invalid-feedback {{errors[0]}}
          validation-provider(rules="required" name="giro comercial" v-slot="{ valid, errors }")
            b-form-group
              label.text-secondary Giro del negocio
              b-form-input(v-model.trim="account.business_turn", placeholder="Giro", :state="valid ? null : false")
              b-form-invalid-feedback {{errors[0]}}
          p.mb-1 2. Punto de recolección
          p.text-secondary.text-sm Los puntos de recolección son los lugares donde la paquetería pasará a recoger los paquetes para envío a tus clientes.
          b-alert(show, variant="warning") Los puntos de recolección no se pueden modificar una vez creados.
          .text-sm.text-secondary.mb-1(v-if="locations.length") Selecciona un punto de recolección o crear uno nuevo
          b-button.mb-3(v-if="!limit_reached || !recolection_points.length", variant="success", block, @click="$emit('createLocation')") Crear punto de recolección
          validation-provider(rules="required" name="punto de recolección" v-slot="{ valid, errors }")
            b-form-select.mb-3(v-model="kanguro_pickup_location_id", v-if="recolection_points.length" :state="valid ? null : false")
              option(:value="null", disabled) --Selecciona punto--
              option(v-for="point in recolection_points", :key="point.pickup_location_id", :value="point.pickup_location_id") {{point.name}}
            b-form-invalid-feedback {{errors[0]}}
          
          .mt-3.text-center.text-danger(v-if="invalid && dirty")
            p.mb-0 Completa los datos faltantes

          .mt-3.text-right
            b-button.px-4(variant="primary" :disabled="invalid" type="submit") Completar registro con Kanguro
</template>

<script>
  import { createNamespacedHelpers, mapActions } from 'vuex'
  const accountController = createNamespacedHelpers('account')
  const locationController = createNamespacedHelpers('location')
  const deliveryController = createNamespacedHelpers('delivery')

  import { EventBus } from '@/helpers/eventBus'
  import axios from 'axios'
  import {UploadFile} from "../../helpers/upload-file";

  // window.initPlaces = function () {
  //   EventBus.$emit('places_loaded')
  // }

  export default {
    data () {
      return {
        kanguro_pickup_location: null,
        address_search: '',
        location_modal: false,
        place_fields: {
          street_number: 'short_name',
          route: 'long_name',
          sublocality_level_1: 'long_name',
          locality: 'long_name',
          administrative_area_level_1: 'short_name',
          country: 'long_name',
          postal_code: 'short_name'
        },
        new_place: {
          full_address: '',
          pickup_location_id: '',
          map_image: '',
          latitude: '',
          longitude: '',
          name: '',
          description: '',
          disponibility_description: '',
          enable: true,
          home_phone: '',
          cell_phone: '',
          email: '',
          reference: '',
          street: '',
          street_number: '',
          colony: '',
          city: '',
          state: '',
          zip: '',
          kanguro_origin_uuid: null,
          validated: false,
          interior_number: '',
          municipality: '',
        },
        availability_days: [
          {
            text: 'Lunes',
            value: 'Lunes'
          },
          {
            text: 'Martes',
            value: 'Martes'
          },
          {
            text: 'Miércoles',
            value: 'Miércoles'
          },
          {
            text: 'Jueves',
            value: 'Jueves'
          },
          {
            text: 'Viernes',
            value: 'Viernes'
          },
          {
            text: 'Sábado',
            value: 'Sábado'
          },
          {
            text: 'Domingo',
            value: 'Domingo'
          }
        ],
        availability_days_picked: [],
        time_from: {
          hh: '12',
          mm: '00',
          A: 'AM'
        },
        time_to: {
          hh: '11',
          mm: '59',
          A: 'PM'
        },
        fields: [
          {
            key: 'name',
            label: 'Nombre Punto de recolección'
          }
        ],
        mapsURL: 'https://maps.googleapis.com/maps/api/staticmap?&size=160x160&maptype=roadmap&region=mx&language=es&key=AIzaSyBYuA0X15QfSmoVwQOL_UxpGRNEV5BYeCo',
        mapsURLBig: 'https://maps.googleapis.com/maps/api/staticmap?&size=500x281&maptype=roadmap&region=mx&language=es&key=AIzaSyBYuA0X15QfSmoVwQOL_UxpGRNEV5BYeCo',
        place: {
          street_number: '',
          postal_code: '',
          full_address: '',
          pickup_location_id: '',
          map_image: '',
          latitude: '',
          longitude: '',
          name: '',
          description: '',
          disponibility_description: '',
          kanguro_origin_uuid: null,
          home_phone: '',
          cell_phone: '',
          email: '',
          reference: '',
          validated: false,
          enable: true,
          interior_number: '',
          municipality: '',
        },
        edit_location_modal: false,
        missing_street_number: false,
        missing_zip: false,
        account_modal: false,
        validated: false,
        kanguro_pickup_location_id: null,
        edit_location_modal: false,
        loadingColony: false,
        map: null,
        showDragMapAlert: false,
        kanguro_pickup_location_created: null
      }
    },
    computed: {
      ...accountController.mapState({
        account: state => state.account,
      }),
      ...locationController.mapState({
        locations: state => state.pickup_locations
      }),
      ...deliveryController.mapState({
        delivery_types: state => state.delivery_types,
        ecommerce_data: state => state.ecommerce_data
      }),
      recolection_points () {
        let locations =  this.locations.filter(l => l.kanguro_origin_uuid)
        let l = this.locations.find(l => l.pickup_location_id == this.kanguro_pickup_location_created)
        if (l) {
          locations.push(l)
        }
        return locations
      },
      weekDays () {
        return this.availability_days.slice(0, 5).map(d => d.text)
      },
      // availabilityText () {
      //   let days, time
      //   if (this.availability_days_picked.length == 7) {
      //     days = 'Todos los días'
      //   } else if (this.availability_days_picked.length == 5 && this.weekDays.diff(this.availability_days_picked).length == 0) {
      //     days = 'De Lunes a Viernes'
      //   } else {
      //     days = `Todos los ${this.availability_days_picked.join(', ')}`
      //   }

      //   time = `de ${this.time_from.hh}:${this.time_from.mm} ${this.time_from.A} a ${this.time_to.hh}:${this.time_to.mm} ${this.time_to.A}`

      //   return days + ' ' + time
      // },
      has_phone () {
        return !!this.new_place.home_phone.length || !!this.new_place.cell_phone.length
      },
      limit_reached () {
        return this.recolection_points.length >= 1
      },
      areTimesPicked () {
        let missingData = false

        for (var key in this.time_from) {
          if (!this.time_from[key]) missingData = true
        }

        for (var key in this.time_to) {
          if (!this.time_to[key]) missingData = true
        }

        return !missingData
      }
    },
    methods: {
      ...mapActions(['delivery/ecommerce', 'account/get', 'account/update', 'location/all', 'location/create', 'location/update', 'kanguro/register_user', 'kanguro/add_address', 'helpers/zip_code']),
      geteEcommerceData () {
        let self = this

        this['delivery/ecommerce']({
          account_id: self.$route.params.account_id,
          callback: res => {
            if (res.error) {
              self.$message.error(res.error)
            }
          }
        })
      },
      getMunicipality () {
        let self = this
        this.loadingColony = true

        this['helpers/zip_code']({
          zipcode: self.new_place.zip,
          callback: res => {
            this.loadingColony = false
            if (res.error) {
              self.$message.error(res.error)
            } else {
              let locations = res.resource.map(el => {
                return {
                  colony: el.d_asenta,
                  municipality: el.D_mnpio,
                  state: el.d_estado,
                  city: el.d_ciudad
                };
              });
              
              if (locations.length) {
                this.new_place.municipality = locations[0].municipality
              }
            }
          }
        })
      },
      getAccountInfo () {
        let self = this

        this['account/get']({
          account_id: self.$route.params.account_id,
          callback: res => {
            if (res.error) {
              self.$message.error(res.error)
            }
          }
        })
      },
      getLocations () {
        let self = this
        // this.showLoadingScreen()

        this['location/all']({
          account_id: self.$route.params.account_id,
          callback: res => {
            self.hideLoadingScreen()
            if (res.error) {
              self.$message.error(res.error)
            }
          }
        })
      },
      updateLocation (modal) {
        modal.preventDefault()
        var self = this

        if (!this.place.name || !this.place.disponibility_description || !this.place.cell_phone) {
          this.place.validated = true
          return
        }

        // this.place.disponibility_description = this.availabilityText
        this.place.enable = true
        this['location/update']({
          ...self.place,
          callback: res => {
            if (res.error) {
              self.$message.error(res.error)
            } else {
              self.$message.success('Punto de recolección actualizado')
              self.getLocations()
              self.edit_location_modal = false
            }
          }
        })
      },
      parseAvailability (place) {
        let text = place.disponibility_description

        try {
          if (text) {
            let times = text.match(/(\d{2}:\d{2} (am|pm))/gmi)
            if (times[0]) {
              let hours, minutes, meridian
              let hm = times[0].split(' ')[0].split(':')
              hours = hm[0]
              minutes = hm[1]
              meridian = times[0].split(' ')[1]

              this.time_from = {
                hh: hours,
                mm: minutes,
                A: meridian
              }
            }

            if (times[1]) {
              let hours, minutes, meridian
              let hm = times[1].split(' ')[0].split(':')
              hours = hm[0]
              minutes = hm[1]
              meridian = times[1].split(' ')[1]

              this.time_to = {
                hh: hours,
                mm: minutes,
                A: meridian
              }
            }
          }
        } catch (e) {}

        try {
          if (text) {
            let days = text.match(/(Todos los días)|(Lunes a Viernes)|Lunes|Martes|Miércoles|Jueves|Viernes|Sábado|Domingo/gmi)
            if (days.length == 1) {
              if (days[0] == 'Lunes a Viernes') {
                this.availability_days_picked = this.weekDays.slice()
              } else if (days[0] == 'Todos los días') {
                this.availability_days_picked = this.availability_days.map(d => d.text)
              }
            } else {
              for (let day of days) {
                this.availability_days_picked.push(day)
              }
            }
          }
        } catch (e) {}
      },
      openPlaceModal (place) {
        this.clearModalData()

        if (place) {
          this.place = Object.assign(this.place, place)
          this.parseAvailability(place)
        }

        this.$nextTick(() => {
          this.edit_location_modal = true
        })
      },
      clearModalData () {
        this.clearObject(this.place)
        this.clearObject(this.new_place)
        this.address_search = ''
        this.availability_days_picked = []
        this.time_from = {
          hh: '12',
          mm: '00',
          A: 'AM'
        }
        this.time_to = {
          hh: '11',
          mm: '59',
          A: 'PM'
        }
      },
      registerUser () {
        let self = this

        this.updateAccount().then(account => {
          self['kanguro/register_user']({
            account_id: self.$route.params.account_id,
            pickup_location_id: self.kanguro_pickup_location_id,
            callback: res => {
              if (res.error) {
                self.$message.error(res.error)
              } else {
                self.getLocations()
                self.account_modal = false
                self.kanguro_pickup_location_id = null
                this.kanguro_pickup_location_created = null
                self.$message.success('Configuración completa, ya puedes utilizar los servicios de paqueteria')
                this.getAccountInfo()
              }
            }
          })
        })
      },
      updateAccount () {
        let self = this
        return new Promise ((resolve, reject) => {
          this['account/update']({
            ...self.account,
            callback: res => {
              if (res.error) {
                self.$message.error(res.error)
                reject(new Error(res.error))
              } else {
                resolve(res.resource)
              }
            }
          })
        })
      },
    },
    mounted () {
      // this.geteEcommerceData()
      // this.getAccountInfo()
      this.getLocations()
      // this.initGoogleMapsAPI()
      EventBus.$on('newKanguroLocation', (event) => {
        console.log(event);
        this.kanguro_pickup_location_created = event
      })
    },
    beforeDestroy () {
      EventBus.$off('newKanguroLocation')
    },
  }
</script>

<style lang="scss" scoped>
</style>

<style>
  .pac-container {
    z-index: 1000000000;
  }

  .vue__time-picker .dropdown {
    top: auto !important;
    bottom: calc(100% + 2px) !important;
  }

  .underline {
    text-decoration: underline;
  }
</style>
